// extracted by mini-css-extract-plugin
module.exports = {"badge":"CompletionBadge_badge__FL2O_"};